import CloseIcon from "../../../../../assets/icons/CloseIcon";
import CustomModal from "../../../../../components/ui/CustomModal";
import { SurveyAnswer } from "../../../../../features/organization/survey/survey.type";
import { CustomModalProps } from "../../../../../types";
import DetailsTemplateCheckbox from "../../templates/_components/DetailsTemplateCheckbox";
import DetailsTemplateDate from "../../templates/_components/DetailsTemplateDate";
import DetailsTemplateDropdown from "../../templates/_components/DetailsTemplateDropdown";
import DetailsTemplateFileUpload from "../../templates/_components/DetailsTemplateFileUpload";
import DetailsTemplateLinerScale from "../../templates/_components/DetailsTemplateLinerScale";
import DetailsTemplateMultipleCheGrid from "../../templates/_components/DetailsTemplateMultipleCheGrid";
import DetailsTemplateMultipleCho from "../../templates/_components/DetailsTemplateMultipleCho";
import DetailsTemplateMultipleChoGrid from "../../templates/_components/DetailsTemplateMultipleChoGrid";
import DetailsTemplateParagraph from "../../templates/_components/DetailsTemplateParagraph";
import DetailsTemplateRating from "../../templates/_components/DetailsTemplateRating";
import DetailsTemplateShortAns from "../../templates/_components/DetailsTemplateShortAns";
import DetailsTemplateTime from "../../templates/_components/DetailsTemplateTime";
type Props = CustomModalProps & {
  handleClose: (val: boolean) => void;
  open?: boolean;
  data: SurveyAnswer;
};
const SurveyAnswersModal = ({ handleClose, data, ...rest }: Props) => {
  const answers = data?.answers?.map((ans) => ({
    answer: ans.answer,
    ...ans.surveyQuestion,
  }));

  return (
    <CustomModal
      title=""
      width={700}
      closable={false}
      handleClose={handleClose}
      okButtonProps={{ className: "!hidden" }}
      cancelButtonProps={{ className: "!hidden" }}
      {...rest}
    >
      <div className="relative">
        <div className="flex text-center justify-between pb-4 border-b border-b-[#D7DFE9] mb-5 sticky top-0 left-0 right-0 z-50 bg-white">
          <h3 className="text-lg font-medium">Survey Response</h3>
          <button onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        <div>
          {answers?.map((data) => {
            switch (data?.question_type) {
              case "short_answer":
                return <DetailsTemplateShortAns key={data?.id} data={data} />;
              case "paragraph":
                return <DetailsTemplateParagraph key={data?.id} data={data} />;
              case "multiple_choice":
                return (
                  <DetailsTemplateMultipleCho
                    viewOnly
                    key={data?.id}
                    data={data}
                  />
                );
              case "checkboxes":
                return (
                  <DetailsTemplateCheckbox
                    key={data?.id}
                    data={data}
                    viewOnly
                  />
                );
              case "dropdown":
                return (
                  <DetailsTemplateDropdown
                    key={data?.id}
                    data={data}
                    viewOnly
                  />
                );
              case "file_upload":
                return (
                  <DetailsTemplateFileUpload
                    key={data?.id}
                    data={data}
                    viewOnly
                  />
                );
              case "linear_scale":
                return (
                  <DetailsTemplateLinerScale
                    data={data}
                    key={data?.id}
                    viewOnly
                  />
                );
              case "rating":
                return (
                  <DetailsTemplateRating data={data} key={data?.id} viewOnly />
                );
              case "multiple_choice_grid":
                return (
                  <DetailsTemplateMultipleChoGrid
                    data={data}
                    key={data?.id}
                    viewOnly
                  />
                );
              case "checkbox_grid":
                return (
                  <DetailsTemplateMultipleCheGrid
                    data={data}
                    key={data?.id}
                    viewOnly
                  />
                );
              case "date":
                return (
                  <DetailsTemplateDate data={data} key={data?.id} viewOnly />
                );
              case "time":
                return (
                  <DetailsTemplateTime data={data} key={data?.id} viewOnly />
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
    </CustomModal>
  );
};

export default SurveyAnswersModal;
